export const isTestVirtualGuardEnabled = () =>
  process.env.REACT_APP_TEST_VIRTUAL_GUARD === "true";

// No familymember nor queueId: the patient lookup and the queue messages are skipped.
export const TEST_CONSULTATION_DATA = {
  reason: "Consulta de prueba",
};
